import Icon from '@forwardflow/ui/Icons'
import { ExampleUSP } from './ExampleUSP'
import { USPSubmitForm } from '@forwardflow/forms'
import { USPListItem } from './USPListItem'

import { useEffect, useRef, useState } from 'react'
import { Skeleton } from 'antd'
import { ICampaignUSP } from '@forwardflow/types/organization'
import CampaignService from '@forwardflow/services/CampaignService'
import {
   useGetActiveLeadSource,
   useGetActiveLeadSourceDetails,
} from '@forwardflow/hooks/customHooks/campaign'
import { useParams } from 'react-router-dom'

export const CampaignUSPs = () => {
   const { title } = useParams()
   const [showForm, setShowForm] = useState(false)
   const { mutate: mutateActiveLeadSource } = useGetActiveLeadSource(
      title || ''
   )

   const {
      data: CampaignDetails,
      isLoading,
      mutate,
   } = useGetActiveLeadSourceDetails(title as string)

   const [selectedUSP, setSelectedUSP] = useState<ICampaignUSP | undefined>(
      undefined
   )

   const scrollRef = useRef<HTMLDivElement>(null)

   const scrollToBottom = () => {
      if (scrollRef.current) {
         scrollRef.current.scrollTop = scrollRef.current.scrollHeight
      }
   }

   // Delete handler
   const handleDeleteUSP = async (uspItem: ICampaignUSP) => {
      try {
         const updatedUSPItems =
            CampaignDetails?.data?.usps?.filter((item) => item !== uspItem) ??
            []

         await CampaignService.updateCampaignUsp(
            title as string,
            updatedUSPItems
         )
      } catch (error) {
         console.error('Failed to delete USP:', error)
      } finally {
         mutate()
         mutateActiveLeadSource()
      }
   }
   useEffect(() => {
      scrollToBottom()
   }, [CampaignDetails?.data?.usps])

   return (
      <div className="flex flex-col flex-1">
         <div className="flex items-center justify-between px-10 py-5 font-medium">
            <p>Add Campaign Unique Selling Points</p>
            <button
               className="h-10 font-medium transition-all rounded w-44 bg-primary/20 hover:bg-primary/40"
               onClick={() => {
                  setSelectedUSP(undefined)
                  setShowForm(!showForm)
               }}
            >
               Add USP
            </button>
         </div>
         <div className="bg-primary/5">
            <div className="flex items-center px-10 py-5 text-[12px] text-white/70 gap-3 bg-primary/10 font-medium">
               <Icon name="CampaignGoals" className="mx-1 fill-white/50" />
               List what values your organization and your team brings
               specifically to the leads in this campaign
            </div>
         </div>
         <ExampleUSP />
         {CampaignDetails?.data?.usps &&
            CampaignDetails?.data?.usps?.length > 0 && (
               <p className="px-10 py-4">
                  {CampaignDetails?.data?.usps.length}{' '}
                  {CampaignDetails?.data?.usps?.length < 1 ? 'USP' : 'USPs'}{' '}
                  added
               </p>
            )}

         <div className="flex flex-col gap-1 ">
            {isLoading ? (
               <div className="px-10 py-3">
                  <Skeleton active />
               </div>
            ) : (
               <div
                  ref={scrollRef}
                  className="flex flex-col gap-1 overflow-y-auto"
               >
                  {CampaignDetails?.data?.usps?.map(
                     (
                        item: { title?: string; description?: string },
                        index: number
                     ) => (
                        <USPListItem
                           key={index}
                           title={item?.title || ''}
                           description={item?.description || ''}
                           onClick={() => {
                              setSelectedUSP(item as ICampaignUSP)
                              setShowForm(true)
                           }}
                           isLastUSP={
                              (CampaignDetails?.data?.usps?.length ?? 0) < 2
                           }
                           onDelete={() =>
                              handleDeleteUSP(item as ICampaignUSP)
                           }
                        />
                     )
                  )}
               </div>
            )}
         </div>

         {showForm && (
            <USPSubmitForm
               leadSource={title as string}
               data={CampaignDetails?.data?.usps || []}
               selectedUSP={selectedUSP}
               onSubmit={() => {
                  mutate()
                  setShowForm(false)
                  setSelectedUSP(undefined)
               }}
               setSelectedUSP={setSelectedUSP}
            />
         )}
      </div>
   )
}
